import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthStore } from '@/shared/store/auth.store';
import { Permisos } from '@/shared/constants/permisos';

export const Route = createFileRoute('/admin/')({
  beforeLoad: () => {
    const permisos = useAuthStore.getState().user?.permisos ?? [];
    if (permisos.includes(Permisos.TECNOLOGIAS_MENU)) {
      throw redirect({ to: '/admin/recet/tecnologias' });
    }
    throw redirect({ to: '/admin/inicio' });
  },
});
